import { Coffee, UtensilsCrossed, Apple, Wine, ShoppingBag, Cookie, Refrigerator, Truck } from "lucide-react";

interface ProductCategoriesProps {
  onCategoryClick?: (category: string) => void;
}

const categories = [
  {
    icon: Coffee,
    name: "Beverages",
    description: "Coffee, Tea & Drinks"
  },
  {
    icon: UtensilsCrossed,
    name: "Kitchen",
    description: "Cooking & Dining"
  },
  {
    icon: Apple,
    name: "Fresh Food",
    description: "Fruits & Vegetables"
  },
  {
    icon: Refrigerator,
    name: "Frozen Food",
    description: "Quality Frozen Items"
  },
  {
    icon: Wine,
    name: "Groceries",
    description: "Pantry Essentials"
  },
  {
    icon: Cookie,
    name: "Snacks",
    description: "Sweet & Savory"
  },
  {
    icon: ShoppingBag,
    name: "Household",
    description: "Daily Essentials"
  },
  {
    icon: Truck,
    name: "Trucks",
    description: "Commercial Vehicles"
  }
];

export const ProductCategories = ({ onCategoryClick }: ProductCategoriesProps) => {
  return (
    <section className="py-8 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl font-bold mb-6">Shop by Category</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {categories.map((category, index) => (
            <div
              key={index}
              className="bg-white p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow cursor-pointer"
              onClick={() => onCategoryClick?.(category.name)}
            >
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
                  <category.icon className="h-6 w-6 text-primary" />
                </div>
                <div>
                  <h3 className="font-medium text-sm">{category.name}</h3>
                  <p className="text-xs text-muted-foreground">{category.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};